import React from 'react';

export function CompactFooter({ onClear, onApply, applyLabel, applyDisabled = false }) {
  return (
    <div className="bsf-popover-footer bsf-popover-footer--pills">
      <button type="button" className="odv2-pill-btn odv2-pill-btn--ghost" onClick={onClear}>
        Limpar
      </button>
      <button
        type="button"
        className="odv2-pill-btn odv2-pill-btn--primary"
        onClick={onApply}
        disabled={applyDisabled}
      >
        {applyLabel}
      </button>
    </div>
  );
}
